module.exports = __webpack_public_path__ + "static/media/main_logo.4b7d8606.png";